import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconCanInvertedStyle0 = cosmosIconCss;

const CosmosIconCanInverted$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconCanInverted extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'c043182c30b1eaa027ba1a9cac0b83fcf6ba8d51', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '2619650bcfba72d837e375b4d2c9fcfba79f0429', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'aa79272d0b0fa59c48dad5b915360bd7a43f5688', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M16 5c0-1.778-1.977-3-4.5-3C8.977 2 7 3.222 7 5v11.644C7 18.19 9.264 19 11.5 19s4.5-.81 4.5-2.356V5Zm-7.5 6.714V7.238a5.9 5.9 0 0 0 3 .762 6.548 6.548 0 0 0 1.851-.262l-1.91 4.777a5.408 5.408 0 0 1-2.941-.801Zm3-8.214c1.654 0 3 .673 3 1.5 0 .627-1.141 1.5-3 1.5s-3-.873-3-1.5c0-.827 1.346-1.5 3-1.5Zm0 14a6.612 6.612 0 0 1-1.932-.266l1.881-4.7h.052a5.442 5.442 0 0 0 3-.8v4.916c-.084.23-1.134.85-3.001.85Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconCanInvertedStyle0; }
}, [1, "cosmos-icon-can-inverted", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-can-inverted"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-can-inverted":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconCanInverted$1);
            }
            break;
    } });
}

const CosmosIconCanInverted = CosmosIconCanInverted$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconCanInverted, defineCustomElement };
